module.exports = __webpack_public_path__ + "static/media/11.bc8c1689.jpg";